import { render, staticRenderFns } from "./role-AdministratorLog.vue?vue&type=template&id=2572f6a6&scoped=true&"
import script from "./role-AdministratorLog.vue?vue&type=script&lang=js&"
export * from "./role-AdministratorLog.vue?vue&type=script&lang=js&"
import style0 from "./role-AdministratorLog.vue?vue&type=style&index=0&id=2572f6a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2572f6a6",
  null
  
)

export default component.exports